import React, { useState } from 'react';

const FreeTrialButton = () => {
  const [isHovered, setIsHovered] = useState(false);

  const containerStyle = {
    position: 'fixed',
    left: '0', // Align button exactly on the left edge
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: '1000',
    transition: 'all 0.3s ease', // Smooth transition for the entire container
    backgroundColor: isHovered ? '#FF4500' : '#FF5733',  // Darker orange on hover for the entire section
    boxShadow: isHovered ? '0 4px 12px rgba(0, 0, 0, 0.15)' : '0 4px 6px rgba(0, 0, 0, 0.1)', // More prominent shadow when hovered
    padding: '10px 5px',
    textAlign: 'center',
    border: '2px solid #FF5733', // Matching border color with the background
    display: 'inline-block', // Ensure the div fits the button size
    // Removed border-radius for rectangular shape
  };

  const buttonStyle = {
    color: 'white',
    textDecoration: 'none',
    fontSize: '16px',
    fontWeight: 'bold',
    writingMode: 'vertical-rl', // Makes the text vertical
    whiteSpace: 'nowrap', // Prevents the text from wrapping onto multiple lines
    textAlign: 'center', // Aligns the text in the center
    transform: 'rotate(180deg)', // Rotates the text so it's displayed from bottom to top
  };

  return (
    <div
      style={containerStyle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <a href="/free-trial" style={buttonStyle}>
        FREE TRIAL
      </a>
    </div>
  );
};

export default FreeTrialButton;
